import React from 'react';
import PropTypes from 'prop-types';

const LoadingSpinner = () => (
    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
);

const Button = ({
    text,
    type = 'button',
    className = '',
    onClick,
    disabled = false,
    loading = false
}) => {
    const baseClasses = 'px-4 py-2 rounded-md font-semibold text-sm transition-colors duration-200 ease-in-out focus:outline-none flex items-center justify-center';

    const typeClasses = {
        primary: 'bg-blue-600 text-white hover:bg-blue-700',
        secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300',
        danger: 'bg-red-600 text-white hover:bg-red-700',
    };

    // `type` is either the HTML button type or a colour style; a style name is
    // never passed to the <button> (an unknown type acts as a form submit).
    const htmlType = ['button', 'submit', 'reset'].includes(type) ? type : 'button';
    const buttonClasses = `${baseClasses} ${typeClasses[type] || typeClasses.primary} ${className} ${loading || disabled ? 'opacity-75 cursor-not-allowed' : ''}`;

    return (
        <button
            type={htmlType}
            className={buttonClasses}
            onClick={onClick}
            disabled={disabled || loading}
        >
            {loading ? (
                <>
                    <LoadingSpinner />
                    <span className="ml-2">{text}</span>
                </>
            ) : (
                text
            )}
        </button>
    );
};

Button.propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['button', 'submit', 'reset', 'primary', 'secondary', 'danger']),
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool
};

export default Button;